export const ERROR_PARAM_NAME = 'error_type'